const defaultBankAccount = (userId, id, data) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  return api.user.defaultAccount(userId, id, data);
};

export default defaultBankAccount;
